<script setup>
import { computed } from 'vue';

const props = defineProps({
  reactions: {
    type: Array,
    default: () => [],
  },
});

const groupedReactions = computed(() => {
  const groups = {};
  props.reactions.forEach(reaction => {
    const emoji = reaction.emoji;
    if (!groups[emoji]) {
      groups[emoji] = { emoji, count: 0, senders: [] };
    }
    groups[emoji].count += 1;
    if (reaction.sender_name) {
      groups[emoji].senders.push(reaction.sender_name);
    }
  });
  return Object.values(groups);
});
</script>

<template>
  <div
    v-if="reactions.length > 0"
    class="flex flex-wrap gap-0.5 -mt-2.5 relative z-10"
  >
    <div
      v-for="group in groupedReactions"
      :key="group.emoji"
      class="inline-flex items-center gap-[3px] pl-1 pr-1.5 py-[2px] rounded-full bg-n-solid-1 dark:bg-n-solid-3 shadow-[0_1px_2px_rgba(0,0,0,0.08)] ring-1 ring-n-slate-3 cursor-default transition-all duration-150 hover:shadow-[0_2px_4px_rgba(0,0,0,0.12)] hover:-translate-y-[1px]"
      :title="group.senders.join(', ')"
    >
      <span class="text-[13px] leading-none">{{ group.emoji }}</span>
      <span
        v-if="group.count > 1"
        class="text-n-slate-11 font-semibold text-[10px] leading-none tabular-nums"
      >
        {{ group.count }}
      </span>
    </div>
  </div>
</template>
